export default __webpack_public_path__ + "media/background-mobile-hm.f82e1ec05f7db981cf5d8dc8608028d3.webp";